import React, { useState } from 'react';
import arrowDownImg from '../../components/LandingPage/images/arrowDown.png'; // New arrow down icon
import arrowUpImg from '../../components/LandingPage/images/arrow.png'; // New arrow up icon

// Import the images you uploaded
import personalizedIcon from '../../components/LandingPage/images/person.png';
import exploreIcon from '../../components/LandingPage/images/compass.png';
import cookbookIcon from '../../components/LandingPage/images/ic_baseline-menu-book.png';
import tailorIcon from '../../components/LandingPage/images/pot.png';
import shareIcon from '../../components/LandingPage/images/majesticons_share.png';
import communityIcon from '../../components/LandingPage/images/fluent_people-community-16-filled.png';

// Data for the cards with PNG icons
const features = [
    {
        icon: personalizedIcon,
        title: 'Personalized Dish Ideas',
        description:
            'Start by telling us what you have in your kitchen, your dietary needs, and the flavors you love. We’ll serve up three spot-on dish ideas! If none hit the mark, we’ll suggest alternatives.',
    },
    {
        icon: exploreIcon,
        title: 'Explore Recipes with a Story',
        description:
            'Each recipe isn’t just a list of ingredients; it’s a journey. Discover easy-to-follow steps, perfect for weeknight dinners or a weekend project.',
    },
    {
        icon: cookbookIcon,
        title: 'Your Personal Cookbook',
        description:
            'Save all your favorite recipes in one spot. Create custom lists like "Quick Weeknight Dinners" or "Holiday Baking." Search by keywords or ingredients.',
    },
    {
        icon: tailorIcon,
        title: 'Tailor Your Recipes',
        description:
            'Access all your saved recipes in one convenient location. Organize recipes into lists tailored to your needs, such as "Weight Loss" or "Holiday Baking."',
    },
    {
        icon: shareIcon,
        title: 'Share with Friends & Family',
        description:
            'Explore variations to adjust recipes to your taste. Discover different ways to prepare your favorite dishes and share them with your loved ones.',
    },
    {
        icon: communityIcon,
        title: 'The Chopping Block Community',
        description:
            'Join a vibrant community where Cook-E members share their recipes and collections. Contribute your own recipes, comment on others, and grow your culinary network.',
    },
];

// FeatureCard component for individual card
const FeatureCard = ({ icon, title, description }) => {
    const [isExpanded, setIsExpanded] = useState(false);

    const toggleExpand = () => {
        setIsExpanded(!isExpanded);
    };

    return (
        <div
            className={`bg-white bg-opacity-70 shadow-lg rounded-xl p-6 w-[411px] ${isExpanded ? 'h-auto' : 'h-[124px]'
                } hover:shadow-2xl transition-all duration-500 ease-in-out`}
            style={{ boxShadow: '0px 0px 30px 0px #AC779D' }}
        >
            <div className="flex justify-between items-center cursor-pointer" onClick={toggleExpand}>
                <div className="flex items-center">
                    <img src={icon} alt={title} className="w-15 h-15 object-contain" />
                    <div className="text-left text-xl p-2 px-4 font-raleway font-extrabold text-black ml-4">{title}</div>
                </div>
                <div className="ml-auto">
                    <img
                        src={isExpanded ? arrowDownImg : arrowUpImg} // Use the new up/down arrow images
                        alt="Arrow"
                        className={`w-10 h-10 object-contain transform transition-transform duration-500 ${isExpanded ? 'rotate-180' : ''
                            }`}
                    />
                </div>
            </div>
            {/* Content to show when expanded */}
            <div
                className={`mt-4 text-gray-700 text-lg overflow-hidden transition-all duration-500 ease-in-out ${isExpanded ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'
                    }`}
            >
                {description}
            </div>
        </div>
    );
};

// Main Transform component
const Transform = () => {
    return (
        <div>
            {/* Heading */}
            <div className="flex justify-center items-center mb-12 md:mb-20">
                <h1
                    className="md:text-5xl text-3xl px-8 md:px-0 font-extrabold text-center text-[#A67FAA]"
                    style={{ fontFamily: 'Raleway, sans-serif' }}
                >
                    Transform Your Experience With Cook-E AI
                </h1>
            </div>

            {/* Flexbox layout of Feature Cards */}
            <div className="flex flex-wrap justify-center items-center gap-x-6 gap-y-4 md:gap-y-16 max-w-8xl mx-auto">
                {features.map((feature, index) => (
                    <FeatureCard
                        key={index}
                        icon={feature.icon}
                        title={feature.title}
                        description={feature.description}
                    />
                ))}
            </div>
        </div>
    );
};

export default Transform;
